import Badge from '../common/Badge';
import { ShiftTypeIcon } from './ShiftTypeIcon';

type ShiftType = 'days_only' | 'nights_only' | 'both';

interface ShiftTypeBadgeProps {
  type: ShiftType;
  className?: string;
}

export const ShiftTypeBadge = ({ type, className = '' }: ShiftTypeBadgeProps) => {
  const getVariant = () => {
    switch (type) {
      case 'days_only':
        return 'success';
      case 'nights_only':
        return 'warning';
      case 'both':
        return 'info';
      default:
        return 'secondary';
    }
  };

  const getLabel = () => {
    switch (type) {
      case 'days_only':
        return 'Days Only';
      case 'nights_only':
        return 'Nights Only';
      case 'both':
        return 'Both Shifts';
      default:
        return '';
    }
  };

  return (
    <Badge variant={getVariant()} className={`px-3 py-1 flex items-center gap-1.5 ${className}`}>
      <ShiftTypeIcon type={type} className="h-3.5 w-3.5" />
      <span>{getLabel()}</span>
    </Badge>
  );
}; 